import {
    Exercise,
    LabelBody,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
} from '../../components';
import { ExerciseStatus } from '../../interfaces';
import { ExerciseData, ExerciseViewProps } from '../../exercises';

export const exerciseData22Completed: ExerciseData = {
    ExerciseView: Module2Exercise2Completed,
    dataKeys: [],
    questions: [],
};

export function Module2Exercise2Completed({ onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="" class="clouds">
            <Spacer />
            <LabelDisplay2 class="mb-10 text-center">
                Godt arbejde!
            </LabelDisplay2>
            <LabelBody class="text-center">
                Du har taget de første skridt i modul 2. Klap dig selv på
                skulderen og fortsæt, når du er klar til det.
            </LabelBody>
            <Spacer />
            <SecondaryButton
                class="my-30"
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                    })
                }
            >
                Tilbage til modulet
            </SecondaryButton>
        </Exercise>
    );
}
